import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { DemoProvider } from "@/lib/demo/store";
import { LangProvider } from "@/lib/i18n/i18n";
import Empresas from "@/pages/Empresas";
import EmpresaPerfil from "@/pages/EmpresaPerfil";
import EmpresaInscripcion from "@/pages/EmpresaInscripcion";
import EmpresaSolicitud from "@/pages/EmpresaSolicitud";
import Backoffice from "@/pages/Backoffice";
import { DemoNav } from "@/components/demo/DemoNav";
import Home from "@/pages/Home";
import Registro from "@/pages/Registro";
import Credencial from "@/pages/Credencial";
import Acceso from "@/pages/Acceso";
import EmpresaScanner from "@/pages/EmpresaScanner";
import EmpresaPortal from "@/pages/EmpresaPortal";
import DashboardUPV from "@/pages/DashboardUPV";

const ScrollTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App">
      <LangProvider>
      <DemoProvider>
        <BrowserRouter>
          <ScrollTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/registro" element={<Registro />} />
            <Route path="/credencial" element={<Credencial />} />
            <Route path="/acceso" element={<Acceso />} />
            <Route path="/empresa/scanner" element={<EmpresaScanner />} />
            <Route path="/empresa/portal" element={<EmpresaPortal />} />
            <Route path="/dashboard" element={<DashboardUPV />} />
            <Route path="/empresas" element={<Empresas />} />
            <Route path="/empresas/inscripcion" element={<EmpresaInscripcion />} />
            <Route path="/empresas/inscripcion/:appId" element={<EmpresaSolicitud />} />
            <Route path="/empresas/inscripcion/:appId/editar" element={<EmpresaInscripcion />} />
            <Route path="/backoffice" element={<Backoffice />} />
            <Route path="/empresas/:id" element={<EmpresaPerfil />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <DemoNav />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </DemoProvider>
      </LangProvider>
    </div>
  );
}

export default App;
